import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Bars3Icon } from '@heroicons/react/24/outline'
import type { ReactElement } from 'react'
import { HabitCard, type HabitCardProps } from './HabitCard'

export function SortableHabitCard(props: HabitCardProps): ReactElement {
  const { habit } = props
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: habit.id })

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      className={isDragging ? 'relative z-20 opacity-80' : undefined}
    >
      <HabitCard
        {...props}
        dragHandle={
          <button
            {...attributes}
            {...listeners}
            type="button"
            aria-label={`Reorder ${habit.name}`}
            className="touch-none rounded-full p-1.5 text-gray-400 hover:bg-gray-100 active:bg-gray-200"
          >
            <Bars3Icon className="h-5 w-5" />
          </button>
        }
      />
    </div>
  )
}
